import React, { useState } from 'react'
import { compose } from 'recompose'
import Script from 'react-load-script'
import { Button, Spin, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
import payRegistrationMutation from '~/App/graphql/mutations/payRegistration.gql'
import { Block } from '../styles'
// import { inject, observer } from 'mobx-react'
const OmiseAlipay = compose(
  injectIntl,
  // withRouter,
  graphql(payRegistrationMutation, {
    name: 'payRegistration'
  })
)(({ intl, registration, payRegistration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted }) => {
  const publicKey = _get(gatewaySettings, 'publicKey', process.env.REACT_APP_OMISE_PUBLIC_KEY) || process.env.REACT_APP_OMISE_PUBLIC_KEY
  const totalAmount = discounted + itemsDiscounted
  const fee = Math.round(gatewayRate * discounted * 100) / 100
  const [paymentLoading, setPaymentLoading] = useState(false)
  const [omiseLoaded, setOmiseLoaded] = useState(false)

  const handleCheckout = async ({ method, type, amount }) => {
    setPaymentLoading(true)
    // eslint-disable-next-line no-undef
    Omise.setPublicKey(publicKey)
    try {
      const source = await new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        Omise.createSource(type, {
          currency: 'thb',
          amount: Math.round(amount * 100)
        }, (statusCode, response) => {
          if (statusCode !== 200) {
            return reject(response.message)
          }
          return resolve(response)
        })
      })

      const { data } = await payRegistration({
        variables: {
          record: {
            registrationId: registration._id,
            eventId: registration.eventId,
            method,
            data: {
              omise: {
                source: { id: source.id },
                returnUri: `${process.env
                  .REACT_APP_BASE_URI}/reg/${registration._id}`
              }
            }
          }
        }
      })
      const authorizeUri = _get(
        data,
        'payRegistration.record.data.omise.charge.authorize_uri'
      )
      if (authorizeUri) window.location.href = authorizeUri
    } catch (err) {
      const { graphQLErrors } = err
      if (graphQLErrors) {
        graphQLErrors.forEach(error => {
          message.error(intl.formatMessage({ id: `api.${error.message}` }))
        })
      } else {
        message.error(err.message)
      }
    } finally {
      setPaymentLoading(false)
    }
  }

  return <Block>
    <Script
      url="https://cdn.omise.co/omise.js.gz"
      onLoad={() => setOmiseLoaded(true)}
      onError={() => console.error('error loading omise')}
    />
    {omiseLoaded ? <React.Fragment>
      <div className="title">
        <FormattedMessage id="paymentMethod.omise_alipay" />
      </div>
      <div>
        {systemFee
          ? <React.Fragment>
            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(discounted - totalSystemFee)
            }} />
            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(totalSystemFee)
            }} />
          </React.Fragment>
          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted)
          }} />
        }
        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" values={{
          amount: intl.formatNumber(fee)
        }} />
        {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(itemsDiscounted)
        }} />}
      </div>
      <Button
        icon="alipay"
        type="primary"
        onClick={e =>
          handleCheckout({
            method: 'omise_alipay',
            type: 'alipay',
            amount: totalAmount
          }
          )}
        loading={paymentLoading}
        className="paymentButton"
      >
        <FormattedMessage id="app.payBaht" values={{
          amount: intl.formatNumber(totalAmount)
        }} />
      </Button>
    </React.Fragment>
      : <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>}
  </Block>
})

export default OmiseAlipay



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseAlipay/OmiseAlipay.js